import React from "react";
import { motion } from "framer-motion";
import { CREDIBILITY } from "../data";

/**
 * TrustedBy strip — the only remnant of the old SummaryBar.
 * Bullets + video + CTAs moved into the Impact accordion row (v1 CHANGE 2).
 */
export default function SummaryBar() {
  return (
    <section
      className="rp-section pt-0 pb-0 relative"
      style={{ background: "#EDE7D9", zIndex: 5 }}
      data-testid="summary-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 lg:px-14">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8 }}
          className="border-y border-[#26201620] py-3"
          data-testid="credibility-marquee"
        >
          <div className="text-center mb-3 rp-eyebrow">Trusted by</div>
          <div className="rp-marquee">
            <div>
              {[...CREDIBILITY, ...CREDIBILITY, ...CREDIBILITY].map((c, i) => (
                <span key={i} className="rp-display text-lg md:text-2xl text-[#262016] whitespace-nowrap">
                  {c} <span className="text-[#B5793F] mx-2">✦</span>
                </span>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
